(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["axnine-subscription-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (value) => String(value).padStart(2, '0');

    const setupPopup = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const dialog = root.querySelector('[data-popup-dialog]');
      const reopen = root.querySelector('[data-popup-reopen]');
      const closeButtons = root.querySelectorAll('[data-popup-close]');
      const countdown = root.querySelector('[data-popup-countdown]');
      const duration = Number(root.dataset.duration || 0);
      const delay = Number(root.dataset.delay || 0);
      const dismissDays = Number(root.dataset.dismissDays || 0);
      const sectionId = root.dataset.sectionId;
      const discountCode = root.dataset.discountCode || '';
      const appliedKey = `axnine-popup-discount-applied-${sectionId}`;
      const deadlineKey = `axnine-popup-deadline-${sectionId}`;
      const dismissedKey = `axnine-popup-dismissed-${sectionId}`;

      const setDismissed = (dismissed) => root.classList.toggle('is-dismissed', dismissed);
      const close = () => {
        if (dialog.open) dialog.close();
        setDismissed(true);
        localStorage.setItem(dismissedKey, String(Date.now() + dismissDays * 86400000));
      };
      const open = () => {
        setDismissed(false);
        document.documentElement.classList.add('axnine-popup-captcha-badge-hidden');
        if (!dialog.open) dialog.showModal();
      };

      closeButtons.forEach((button) => button.addEventListener('click', close));
      const signupForm = root.querySelector('form.axnine-popup__form');
      if (signupForm) signupForm.addEventListener('submit', () => sessionStorage.removeItem(appliedKey));
      reopen.addEventListener('click', open);
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        close();
      });

      if (countdown && duration > 0) {
        let deadline = Number(localStorage.getItem(deadlineKey));
        if (!deadline || deadline <= Date.now()) {
          deadline = Date.now() + duration * 1000;
          localStorage.setItem(deadlineKey, String(deadline));
        }

        const render = () => {
          let remaining = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
          if (remaining === 0) {
            deadline = Date.now() + duration * 1000;
            localStorage.setItem(deadlineKey, String(deadline));
            remaining = duration;
          }
          countdown.querySelector('[data-days]').textContent = pad(Math.floor(remaining / 86400));
          countdown.querySelector('[data-hours]').textContent = pad(Math.floor((remaining % 86400) / 3600));
          countdown.querySelector('[data-minutes]').textContent = pad(Math.floor((remaining % 3600) / 60));
          countdown.querySelector('[data-seconds]').textContent = pad(remaining % 60);
        };

        render();
        window.setInterval(render, 1000);
      }

      const submitted = Boolean(root.querySelector('[data-popup-success]'));
      if (submitted && discountCode && !sessionStorage.getItem(appliedKey)) {
        sessionStorage.setItem(appliedKey, '1');
        localStorage.setItem(dismissedKey, String(Date.now() + Math.max(1, dismissDays) * 86400000));
        const returnTo = new URL(window.location.href);
        returnTo.searchParams.delete('customer_posted');
        returnTo.searchParams.delete('contact_posted');
        returnTo.hash = '';
        const discountUrl = new URL(`/discount/${encodeURIComponent(discountCode)}`, window.location.origin);
        discountUrl.searchParams.set('redirect', returnTo.pathname + returnTo.search);
        window.location.replace(discountUrl.href);
        return;
      }
      const dismissedUntil = Number(localStorage.getItem(dismissedKey) || 0);
      const designMode = Boolean(window.Shopify && window.Shopify.designMode);
      if (submitted || dismissedUntil <= Date.now() || designMode) window.setTimeout(open, submitted || designMode ? 0 : delay);
      else setDismissed(true);
    };

    const initialize = () => {
      document.querySelectorAll('[data-axnine-popup]').forEach(setupPopup);
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();
})();
